<template>
  <div class="yeb-out-success-conponet">
    <PageLayout contentBgcolor="#FFF">
      <Appbar>
        <div class="toolsright" slot="left">
          <v-btn :color="$vuetify.theme.themes.light.headerColor" @click="routeBack({ numb: -2 })" text>
            <i class="iconfont jiantou-left"></i>
          </v-btn>
        </div>
        <v-toolbar-title>
          <span style="font-size: 17px; text-align: center" :style="'color:' + $vuetify.theme.themes.light.headerColor">
            {{ `结果详情` }}
          </span>
        </v-toolbar-title>
      </Appbar>
      <div v-if="type == 'out'" class="page-content">
        <div class="out-content">
          <i class="iconfont xiaoxi-chenggong transout" style="color:#6AC95B"></i>
          <span :style="'color:' + $vuetify.theme.themes.light.primary" class="stitle">
            {{sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1?"提交成功":"转出成功"}}
            </span>
          <span class="ssub" v-if="sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1">
            转出{{ amount }}{{ app_my_config.amountUnit.name }}至账户{{ app_my_config.balance.name }}
            <br />
            <span>
              转出余额宝申请已提交,请等待审批
            </span>
          </span>
          <span class="ssub" v-else>
            成功转出{{ amount }}{{ app_my_config.amountUnit.name }}至账户{{ app_my_config.balance.name }}
          </span>
        </div>
      </div>
      <div v-else class="page-content">
        <div class="stepper-row">
          <div class="stepper-column">
            <div
              class="stepper-icon"
              style="width: 50px; height: 50px"
              :style="'background-color:' + $vuetify.theme.themes.light.primary"
            >
              <i class="iconfont qian"></i>
            </div>
            <div class="column-border"></div>
          </div>
          <div class="stepper-content stepper-content-50" style=" height: 50px;">
            <div
              v-if="sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1"
              class="stepper-title"
              style="font-weight: 700"
            >
              转入{{ amount }}{{ app_my_config.amountUnit.name }}
            </div>
            <div v-else class="stepper-title" style="font-weight: 700">
              成功转入{{ amount }}{{ app_my_config.amountUnit.name }}
            </div>
            <div
              class="stepper-sub"
              v-if="sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1"
            >
              转入余额宝申请已提交,请等待审批
            </div>
            <div class="stepper-sub" v-else>今天</div>
          </div>
        </div>
        <div class="stepper-row">
          <div class="stepper-column">
            <div class="column-border"></div>
          </div>
        </div>
        <div class="stepper-row">
          <div class="stepper-column">
            <div class="stepper-icon">
              <i class="iconfont dengdai"></i>
            </div>
            <div class="column-border"></div>
          </div>
          <div class="stepper-content  stepper-content-50 stepper-content-32">
            <template v-if="sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1">
              <div class="stepper-sub">审批通过后开始计算收益</div>
            </template>
            <template v-else>
              <div class="stepper-title">{{ yjsy }}</div>
              <div class="stepper-sub">开始计算收益</div>
            </template>
          </div>
        </div>
        <div class="stepper-row">
          <div class="stepper-column">
            <div class="column-border"></div>
          </div>
        </div>
        <div class="stepper-row">
          <div class="stepper-column">
            <div class="stepper-icon">
              <i class="iconfont dengdai"></i>
            </div>
          </div>
          <div class="stepper-content stepper-content-50 stepper-content-32">
            <template v-if="sysParam.yeb_in_is_need_approve == 1 || sysParam.yeb_out_is_need_approve == 1">
              <div class="stepper-sub">收益到账</div>
            </template>
            <template v-else>
              <div class="stepper-title">{{ yjsy2 }}</div>
              <div class="stepper-sub">收益到账</div>
            </template>
          </div>
        </div>
      </div>
      <div
        :style="'background-color:' + $vuetify.theme.themes.light.buttonColor"
        @click="gobackToYeb"
        class="comfirm-button"
      >
        完成
      </div>
    </PageLayout>
  </div>
</template>
<script>
import Appbar from '@c/layout/Appbar'
import PageLayout from '@c/layout/PageLayout'
import appConfigMixins from '@c/mixins/appConfig.mixins'

export default {
  mixins: [appConfigMixins],
  data: function() {
    let type = this.$route.query.type || 'in'
    let amount = this.$route.query.amount || '0'
    return {
      type,
      amount
    }
  },
  computed: {
    sysParam() {
      return this.$store.state.sysParameter.sysParam
    },
    userInfo() {
      return this.$store.state.user.userInfo
    },
    serviceTime() {
      return this.$store.state.service.serviceTime
    },
    yjsy() {
      const moment = this.$tools
        .moment(this.serviceTime)
        .locale('zh-cn')
        .add(0, 'd')
      const yn = moment.format('MM-DD')
      const xq = moment.format('dddd')
      return `${yn} ${xq}`
    },
    yjsy2() {
      const moment = this.$tools
        .moment(this.serviceTime)
        .locale('zh-cn')
        .add(1, 'd')
      const yn = moment.format('MM-DD')
      const xq = moment.format('dddd')
      return `${yn} ${xq}`
    }
  },
  components: {
    PageLayout,
    Appbar
  },
  mounted() {
    this.$store.dispatch('service/getServiceTime', false)
  },
  methods: {
    gobackToYeb() {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'newPage',
            url: 'Yeb'
          })
        )
      } else {
        this.routeBack({ numb: -2 })
      }
    }
  }
}
</script>
<style lang="scss" >
.yeb-out-success-conponet {
  flex: 1;
  .toolsright {
    display: flex;
    .headerbuttom {
      min-width: 30px;
      height: 44px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .page-content {
    padding-top: 30px;
    i.transout {
      font-size: 56px;
    }
    .stitle {
      font-size: 16px;
    }
    .ssub {
      font-size: 12px;
      color: #999;
      margin-top: 6px;
      text-align: center;
    }
    .stepper-row {
      display: flex;
    }
    .stepper-column {
      width: 80px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .stepper-content {
      flex: 1;
    }
    .stepper-content-50 {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .stepper-content-32 {
      height: 32px;
    }
    .stepper-icon {
      border-radius: 50%;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #ccc;
      i {
        font-size: 20px;
        color: #fff;
      }
    }
    .stepper-title {
      font-size: 14px;
    }
    .stepper-sub {
      font-size: 12px;
      color: #666;
    }
    .column-border {
      width: 2px;
      background-color: #ccc;
      min-height: 20px;
    }
  }
  .out-content {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .comfirm-button {
    margin: 50px 12px 0;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
  }
}
</style>
